import Document from "../general/document";

export interface CustomerData {
  name: string;
}

class Customer extends Document<CustomerData> {
  get title() {
    return this.data.name;
  }
}

export default Customer;
